import Axios from '../instance/Axios';
import axiosInstance from '../instance/AxiosInstance';
const getCountryApi = async () => {
  try {
    const response = await axiosInstance.get('/common/getcountry');
    return response.data.data;
  } catch (error) {
    // Handle error (axiosInstance automatically throws errors for 4xx and 5xx status codes)
    throw new Error(error.response?.data?.message || 'Failed to Fetch Country');
  }
};
export const getStateApi = async (id) => {
  try {
    const response = await axiosInstance.get(`/common/getState/${id.payload}`);
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to Fetch State');
  }
};
export const getCityApi = async (id) => {
  try {
    const response = await axiosInstance.get(`/common/getcities/${id.payload}`);

    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to Fetch State');
  }
};
export default getCountryApi;
export const getCountryAirportApi = async () => {
  try {
    const response = await axiosInstance.get('/common/getcountry');
    return response.data.data;
  } catch (error) {
    // Handle error (axiosInstance automatically throws errors for 4xx and 5xx status codes)
    throw new Error(error.response?.data?.message || 'Failed to Fetch Country');
  }
};
export const getStateAirportApi = async (id) => {
  try {
    const response = await axiosInstance.get(`/common/getState/${id.payload}`);

    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to Fetch State');
  }
};
